import { createContext, useContext, useLayoutEffect, useState, type ReactNode } from "react"

type Theme = "light" | "dark"

interface ThemeContextType {
    theme: Theme
    setTheme: (theme: Theme) => void
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined)

export function ThemeProvider({ children }: { children: ReactNode }) {
    // Light mode hidden for now: dark-glass / glitch brand is not light-mode ready. Always dark.
    const [theme, setTheme] = useState<Theme>("dark")

    useLayoutEffect(() => {
        const root = window.document.documentElement
        root.classList.remove("light", "dark")
        root.classList.add("dark")
        if (typeof window !== "undefined") localStorage.setItem("theme", "dark")
    }, [])

    return (
        <ThemeContext.Provider value={{ theme, setTheme }}>
            {children}
        </ThemeContext.Provider>
    )
}

export function useTheme() {
    const context = useContext(ThemeContext)
    if (context === undefined) {
        throw new Error("useTheme must be used within a ThemeProvider")
    }
    return context
}
